import { render, staticRenderFns } from "./plist.vue?vue&type=template&id=0a10e4cf&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./plist.vue?vue&type=script&lang=js&"
export * from "./plist.vue?vue&type=script&lang=js&"
import style0 from "./plist.vue?vue&type=style&index=0&id=0a10e4cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10e4cf",
  null
  
)

export default component.exports